import { render, staticRenderFns } from "./Mortgages.vue?vue&type=template&id=1a09ffbb&"
import script from "./Mortgages.vue?vue&type=script&lang=ts&"
export * from "./Mortgages.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports